import { messageError } from '../../components/message';
import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import { API_PREFIX } from '../config';

export const getLogout = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/user/logout`;
      const response = await api.commonRequest('POST', url);
      return !!(await parsedResponse(response, 'data'));
    } catch (err: any) {
      if (err instanceof APIError) {
        messageError(err?.apiError?.message);
      }
      return null;
    }
  });
